// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__1EksR","phoneAuth":"styles_phoneAuth__3yA1W","title":"styles_title__3xRUV"};